import { Component, Input, SecurityContext } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-person',
    templateUrl: './person.component.html',
    styleUrls: ['./person.component.scss'],
    standalone: true
})
export class PersonComponent {

    @Input() totalScore?: number;

    private readonly initialHeight = 186;

    get upperHeight(): any {
        if(this.totalScore) {
            return this.initialHeight - (this.initialHeight * this.totalScore) / 100;
        }
        return this.initialHeight
    }

    get lowerHeight(): any {
        if(this.totalScore) {
            return (this.initialHeight * this.totalScore) / 100;
        }
        return 0
    }

    get upperViewBox(): string {
        if(this.totalScore) {
            return `0 0 80 ${this.upperHeight}`;
        }
        return `0 0 80 ${this.initialHeight}`;
    }

    get lowerViewBox(): string {
        if(this.totalScore) {
            return `0 ${this.upperHeight} 80 ${this.lowerHeight}`;
        }
        return `0 ${0} 80 ${0}`;
    }

    get colorRed(): string {
        if(this.totalScore) {
            return '#D81A53';
        }
        return '#B5B3B3';
    }

    get colorBlue(): string {
        if(this.totalScore) {
            return '#00BFCE';
        }
        return '#B5B3B3';
    }

}
